import React from "react";

import ProjectItem from "../components/ProjectItem";

export default ({ work }) => (
  <div>
    <p className="headline">Projects</p>
    {Array.isArray(work) &&
      work.map((project, index) => (
        <ProjectItem key={index} project={project} />
      ))}
  </div>
);
